import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MarkerDetailWrapper } from '../wrappers/marker_detail_wrapper';
import { MarkerDetailTitle } from './marker_detail/title';
import { MarkerDetailContent } from './marker_detail/content';
import { MarkerDetailLink } from './marker_detail/link';
import { Context } from '../../store/context';

function MarkerDetail({ id, title, direction, schedule, phone, lat, lng }) {
  const { activeMarkerId, setActivemarkerid } = useContext(Context);

  return (
    <>
      <MarkerDetailWrapper onClick={() => setActivemarkerid(id)}>
        <MarkerDetailTitle active={id === activeMarkerId}>
          {title}
        </MarkerDetailTitle>
        <MarkerDetailContent>
          <p style={{ marginTop: 0, marginBottom: 0 }}>
            <strong>Dirección:</strong> {direction}
          </p>
          <p style={{ marginTop: 0, marginBottom: 0 }}>
            <strong>Horario:</strong> {schedule}
          </p>
          <p style={{ marginTop: 0, marginBottom: '30px' }}>
            <strong>Teléfono:</strong> {phone}
          </p>
        </MarkerDetailContent>
        <MarkerDetailLink>
          <a
            style={{ color: 'white' }}
            href={`https://www.google.com/maps/dir//${lat},${lng}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            ¿Cómo llegar?
          </a>
        </MarkerDetailLink>
      </MarkerDetailWrapper>
    </>
  );
}

MarkerDetail.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  direction: PropTypes.string,
  schedule: PropTypes.string,
  phone: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
  active: PropTypes.bool,
  setActive: PropTypes.func,
};

export default MarkerDetail;
